import { Button, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { Filter } from "../../components/Filter";
import { Select } from "../../components/Forms/Select";
import { useContestation } from "../../hooks/useContestation";
import { DisputeModel } from "../../models/Dispute";
import { DoubleUserIcon } from "../../styles/icons/DoubleUserIcon";
import { formatDate, showToast } from "../../utils";
import { DetailsModal } from "./_DetailsModal";


export function Contestacao() {
    const { getInitialData, putDisputeCharge } = useContestation();
    const [initialData, setInitialData] = useState<DisputeModel[]>([]);
    const [filteredInitialData, setFilteredInitialData] = useState<DisputeModel[]>([]);
    const [selectedDispute, setSelectedDispute] = useState({} as DisputeModel)
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);


    const phaseOptions = [
        {
            name: 'Contato com buyer',
            value: 'IN_CONTACT_WITH_BUYER'
        },
        {
            name: 'Contato com seller',
            value: 'IN_CONTACT_WITH_SELLER'
        },
        {
            name: 'Aguardando buyer',
            value: 'AWAITING_BUYER_RESPONSE'
        },
        {
            name: 'Aguardando seller',
            value: 'AWAITING_SELLER_RESPONSE'
        },
        {
            name: 'Aguardando provedor',
            value: 'AWAITING_PROVIDER_RESPONSE'
        },
    ]
    const motiveOptions = [
        {
            name: 'Fraude',
            value: 'FRAUD'
        },
        {
            name: 'Autofraude',
            value: 'AUTOFRAUD'
        },
        {
            name: 'Desacordo comercial',
            value: 'COMMERCIAL_DISAGREEMENT'
        },
        {
            name: 'Outros',
            value: 'OTHERS'
        },
    ]
    const handleChangePhase = async (id: string, value: string) => {
        const updatedInitialData = [...initialData]
        const getItemIndex = updatedInitialData.findIndex(uid => uid?.uuidCharge === id)
        const disputeFormData = {
            disputeStageStatus: value,
            reasonType: updatedInitialData[getItemIndex]?.reasonType ?? "OTHERS",
            otherReason: ""
        }
        await putDisputeCharge(id, disputeFormData)
    }

    const handleChangeMotive = async (id: string, value: string) => {
        const updatedInitialData = [...initialData]
        const getItemIndex = updatedInitialData.findIndex(uid => uid?.uuidCharge === id)
        const motiveFormData = {
            disputeStageStatus: updatedInitialData[getItemIndex]?.disputeStageStatus ?? "IN_CONTACT_WITH_BUYER",
            reasonType: value,
            otherReason: ""
        }
        await putDisputeCharge(id, motiveFormData)
    }

    const columns: ColumnsType<DisputeModel> = [
        {
            key: "sellerName",
            title: "Seller",
            dataIndex: "sellerName",
            render: (sellerName, record) => (
                <Text>
                    {record?.sellerName}
                </Text>
            )
        },
        {
            key: "contestationDeadline",
            title: "Data limite",
            dataIndex: "contestationDeadline",
            render: (contestationDeadline, record) => (
                <Text>
                    {formatDate(record?.contestationDeadline)}
                </Text>
            )
        },
        {
            key: "authorizationCode",
            title: "Cod. Aut.",
            dataIndex: "authorizationCode",
            render: (authorizationCode, record) => (
                <Text>
                    {record?.authorizationCode}
                </Text>
            )
        },
        {
            key: "authorizationNsu",
            title: "NSU",
            dataIndex: "authorizationNsu",
            render: (authorizationNsu, record) => (
                <Text>
                    {record?.authorizationNsu}
                </Text>
            )
        },
        {
            key: "uuidCharge",
            title: "Fase",
            dataIndex: "uuidCharge",
            render: (uuidCharge, record) => (
                <Select
                    maxW="250px"
                    name="phase"
                    onChange={(e) => {
                        handleChangePhase(record?.uuidCharge, e.currentTarget.value)
                    }}
                    defaultValue={record?.disputeStageStatus}
                >
                    {phaseOptions?.map((op, index) => <option key={index} value={op.value}>{op.name}</option>)}
                </Select>
            )
        },
        {
            key: "uuidCharge",
            title: "Motivo",
            dataIndex: "uuidCharge",
            render: (uuidCharge, record) => (
                <Select
                    maxW="250px"
                    name="motive"
                    defaultValue={record?.reasonType}
                    onChange={(e) => {
                        handleChangeMotive(record?.uuidCharge, e.currentTarget.value)
                    }}
                >
                    {motiveOptions?.map((op, index) => <option key={index} value={op.value}>{op.name}</option>)}
                </Select>
            )
        },
        {
            key: "buttonOptions",
            title: "",
            render: (uuidCharge, record) => (
                <Button
                    onClick={() => {
                        setSelectedDispute(record)
                        setIsDetailsModalOpen(true);
                    }}
                    borderRadius="2px"
                    backgroundColor="#C3CAD7"
                    fontWeight={500}

                >
                    Detalhes
                </Button>
            ),
        },
    ];
    useEffect(() => {
        getInitialData().then(res => {
            setInitialData(res?.data)
            setFilteredInitialData(res?.data)
        })
        //eslint-disable-next-line
    }, [isDetailsModalOpen])

    async function handleSearch(search?: string) {
        setLoading(true);

        if (search === "") {
            try {
                const response = await getInitialData()
                setInitialData(response?.data)
                setFilteredInitialData(response?.data)

            } catch (error) {
                error?.response?.data?.errors?.map((error: any) => (
                    showToast({
                        type: "error",
                        message: `${error?.code} - ${error?.description}`
                    })
                ));
            }
            finally {
                setLoading(false);
            }
        }
         else {
            const filteredInitialData = initialData?.filter(data => data?.sellerName?.toLowerCase().includes(search?.toLowerCase()));
            setFilteredInitialData(filteredInitialData)
            setLoading(false);
        }
    }

    return (
        <>
            <DetailsModal
                isOpen={isDetailsModalOpen}
                onClose={() => setIsDetailsModalOpen(false)}
                selectedDispute={selectedDispute}
            />
            <Flex 
                justifyContent="center"
            >
                <Stack w="100%" gap={2}>
                    <Flex
                        align="center"
                        gap="16px"
                    >
                        <DoubleUserIcon />
                        <Heading fontSize="24px">
                            Contestação
                        </Heading>
                    </Flex>
                    <Filter
                        placeholder="Buscar cliente"
                        needToSubmit
                        onSubmitSearch={handleSearch}
                        loading={loading}

                    />
                    <Table<DisputeModel>
                        columns={columns}
                        dataSource={filteredInitialData}
                        rowKey={(record) => record.uuidCharge}
                        pagination={false}
                        locale={{ emptyText: "Sem contestaçoes cadastradas" }}
                    />
                </Stack>
            </Flex>
        </>
    )
}